import ArrowRight from "../../svgs/arrow-right.svg?react";
import { useKontaxUserContext } from "../contexts/KontaxUserContext";
import UserInfoExcerpt from "./UserInfoExcerpt";
import {
  UserInfoExcerptWrapper,
  UserInfoWrapper,
  UserNameWrapper,
  ViewMoreWrapper,
} from "./UserInfoExcerpt/styledComponents";
import { UserInfoDrawerSources } from "./UserInfoExcerpt/UserInfoDrawer";

/**
 * Sticky customer-info banner shown above tax-ops tables (VerificationView and
 * ReceiptOverview — SMT-997). Renders the customer's key VAT/business info with
 * a "View more info" link that opens the full UserInfoDrawer.
 *
 * Must be rendered inside a <KontaxUserContext email={...}> so the user, notes
 * and loading state resolve from context.
 */
const CustomerInfoBanner = () => {
  const { user, notes, isLoading } = useKontaxUserContext();

  return (
    <UserInfoExcerpt
      isSticky
      user={user}
      notes={notes}
      source={UserInfoDrawerSources.ACCOUNTING}
      isLoading={isLoading}
      renderExcerptData={(excerptData) => {
        return (
          <UserInfoExcerptWrapper>
            <UserNameWrapper>
              {excerptData.user.firstName} {excerptData.user.lastName}
            </UserNameWrapper>

            <span>
              {excerptData.vatDetails?.isKleinunternehmer && (
                <UserInfoWrapper>Kleinunternehmer</UserInfoWrapper>
              )}
              {excerptData.user.businessTypeComment && (
                <UserInfoWrapper>
                  {excerptData.user.businessTypeComment}
                </UserInfoWrapper>
              )}
              <UserInfoWrapper>
                {excerptData.vatDetails?.frequency} (
                {excerptData.vatDetails?.year})
              </UserInfoWrapper>
              <UserInfoWrapper>{excerptData.notesCount}</UserInfoWrapper>
            </span>

            <ViewMoreWrapper>
              <span>View more info</span>
              <ArrowRight />
            </ViewMoreWrapper>
          </UserInfoExcerptWrapper>
        );
      }}
    />
  );
};

export default CustomerInfoBanner;
